import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Subscriptions';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of subscription',
	breadcrumbs: [
		{
			title: title,
			link: '/hydrowallet/subscriptions',
		},
	],
};

export default function EditSubscription() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		{ id } = useParams(),
		[quantity, setQuantity] = useState(0),
		[cost, setCost] = useState(0),
		types = [
			{
				value: 'free',
				label: 'Free',
			},
			{
				value: 'fixed',
				label: 'Fixed',
			},
		],
		[type, setType] = useState(),
		[clients, setClients] = useState([]),
		[client, setClient] = useState(),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		[data, setData] = useState();

	async function onGet() {
		let res = await resources.subscription
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			setData(res.data);
			const typeFilter = types.filter(
				(type) => type.value === res.data?.type
			);
			setType(typeFilter[0]);
			setCost(res.data?.costLitre);
			setQuantity(res.data?.quantity);
		} else if (res.status === 403) {
			setFail(true);
		}

		let clientsFromApi = await resources.customer
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (clientsFromApi.status === 200) {
			let covertaToLabelValue = [];
			clientsFromApi.data.docs.forEach((el) => {
				if (res.data.client === el.id) {
					setClient({
						value: el.id,
						label: el.name,
					});
				}

				covertaToLabelValue.push({
					value: el.id,
					label: el.name,
				});
			});
			setClients(covertaToLabelValue);
		}
		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, [id]);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		object.quantityHDP = quantity;
		setLoader(true);
		setErrors({});
		let res = await resources.subscription
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/hydrowallet/subscriptions');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Client{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										name="client"
										options={clients}
										isSearchable
										isClearable
										value={client}
										className={
											errors['client']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['client'] && (
										<div className="invalid-feedback">
											{errors['client']}
										</div>
									)}
								</div>

								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Type{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										name="type"
										options={types}
										onChange={setType}
										value={type}
										isSearchable
										isClearable
										className={
											errors['type'] ? ' is-invalid' : ''
										}
									/>
									{errors['type'] && (
										<div className="invalid-feedback">
											{errors['type']}
										</div>
									)}
								</div>

								<Field
									name="title"
									className="mb-3"
									error={errors['title']}
									defaultValue={data?.title}
									required
								>
									Title
								</Field>

								{/* <Field
												name="quantityHDP"
												type="number"
												className="mb-3"
												error={errors['quantityHDP']}
												required
												defaultValue={data?.quantityHDP}
											>
												Quantity HDP
											</Field> */}

								{type?.value === 'free' ? (
									<Field
										name="quantity"
										type="number"
										className="mb-3"
										error={errors['quantity']}
										value={1}
										defaultValue={data?.quantity}
										required
									>
										Quantity minimum
									</Field>
								) : (
									<Field
										name="quantity"
										type="number"
										className="mb-3"
										error={errors['quantity']}
										onChange={(e) =>
											setQuantity(e.target.value)
										}
										defaultValue={data?.quantity}
										required
									>
										Quantity
									</Field>
								)}

								<Field
									name="costLitre"
									type="number"
									className="mb-3"
									step="any"
									error={errors['costLitre']}
									onChange={(e) => setCost(e.target.value)}
									defaultValue={data?.costLitre}
									required
								>
									Cost per litre
								</Field>
								<Field
									type="number"
									className="mb-3"
									error={errors['cost']}
									value={
										type?.value === 'free'
											? cost
											: cost * quantity
									}
									required
									readOnly
								>
									Subscription cost
								</Field>

								<Field
									name="durationCycle"
									type="number"
									className="mb-3"
									error={errors['durationCycle']}
									defaultValue={data?.durationCycle}
									required
								>
									subscription duration
								</Field>

								<Field
									name="bonusLimit"
									type="number"
									className="mb-3"
									error={errors['bonusLimit']}
									defaultValue={data?.bonusLimit}
									required
								>
									Bonus limit
								</Field>

								<Field
									name="creditLimit"
									type="number"
									className="mb-3"
									error={errors['creditLimit']}
									defaultValue={data?.creditLimit}
									required
								>
									Credit limit
								</Field>

								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									defaultValue={data?.description}
									className="mb-3"
								>
									Note
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
